/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';
import { extend } from '../../extend/index.js';
import { env } from '../../env/index.js';
import '../../extend/register/index.js';
import '../../../index-f24a9ec1.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../../index-892d8eee.js';

var isAndroid = env.isAndroid, isIOS = env.isIOS, version = env.version;
/**
 * 当前菜鸟App版本，是否支持播放穿山甲视频。
 * 经常用的场景：不支持播放的情况下，提前隐藏播放按钮，避免不支持的环境播放视频。
 */
var cnIsSupportPlayAdVersion = function () {
    return (isAndroid && (version === null || version === void 0 ? void 0 : version.gte('6.9.0'))) || (isIOS && (version === null || version === void 0 ? void 0 : version.gte('6.9.3')));
};
// 执行广告视频
var showAd = extend({
    web: {
        windvane: {
            cn: function (options, context) {
                context === null || context === void 0 ? void 0 : context.WVCall('CNHybridRewardedVideoAd.showAd', __assign({ orientation: 1 }, options));
            },
        },
    },
});
var cn = (function (options) {
    var success = options.success, fail = options.fail, overtime = options.overtime;
    if (!cnIsSupportPlayAdVersion()) {
        fail({
            errMsg: '当前菜鸟App版本，不支持cnPreloadAdVideo API',
        });
        return;
    }
    showAd(options)
        .then(function (res) {
        var _a;
        var isPlaySuccess = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.isValid;
        if (isPlaySuccess) {
            success();
        }
        else {
            fail({ errMsg: '客户端播放失败' });
        }
    })
        .catch(fail);
    // @游龙实测showAd经常超时，加上个超时阈值反馈
    setTimeout(function () {
        return fail({
            errMsg: '客户端执行超时',
        });
    }, overtime);
});

export { cn as default };
